/**
 * Re-usable global constants
 */
export const CLIENT_DELOITTE = "Clients/Deloitte";

export const CLIENT_DEFAULT = "Clients/Default";

export const ATTACHMENT_SOURCE = {
    UDA: "uda",
    FLOW_APP_UPLOAD: "flow_app_upload",
};
